// Generated by GitHub Copilot
import { BaseIdModel } from '#core/entities/shared/BaseModels.ts'
import { initialsFromParts } from '#core/utils/string-case.ts'
import { Type } from 'class-transformer'
import { Permission } from '#core/entities/auth/roles/Permission'

/** Full user record as returned by the company-scoped user list endpoint. */
export default class UserCompany extends BaseIdModel {
  first_name: string | null = null
  last_name: string | null = null
  email: string | null = null
  profile_picture: { id: string; filename: string } | null = null
  role_id: string | null = null
  role_name: string | null = null
  @Type(() => Permission)
  personal_permissions: Permission[] | null = null
  enabled: boolean = true
  mfa_required: boolean = false
  sso_required: boolean = false
  @Type(() => Date)
  last_logged_in: Date | null = null

  /** Returns the user's full name, falling back to email or id. */
  get displayName(): string {
    const full = [this.first_name, this.last_name].filter(Boolean).join(' ')
    return full || this.email || this.id
  }

  /** Returns up to two initials derived from the display name. */
  get initials(): string {
    return initialsFromParts(this.first_name, this.last_name) || (this.email || this.id).slice(0, 2).toUpperCase()
  }
}
